export default "__VITE_ASSET__d0a2a59e__"